import {createSelector} from 'reselect';

import {DeliveryTrackerJobStatuses} from '~/shared/consts/deliveryTrackerConsts';

import {AppState} from '../../configStore';

export const selectUserLastOrderScooberJob = (state: AppState) => state.userLastOrderScooberJob.data;

const selectTrakcerUrl = createSelector(selectUserLastOrderScooberJob, result => result?.trackerUrl);
const selectStatus = createSelector(selectUserLastOrderScooberJob, result => result?.status);

export const selectIsScooberJobCanceled = createSelector(
  selectStatus,
  status => status === DeliveryTrackerJobStatuses.Canceled,
);

export const selectIsTrackerUrlEmpty = createSelector(
  selectTrakcerUrl,
  trackerUrl => !trackerUrl,
);
